<template>

<div class="main inventory">

	<div class="list-view no-sub-header">

		<div class="filters">
			<p>Click a distributor to edit your account details.</p>
			<p>Use the <i class="fas fa-grip-vertical"></i> handle to drag distributors into preferred order.</p>
			<button class="button action spaced" @click="savePreferenceOrder()"><span>Save Preference Order</span></button>
			<p class="message">{{ filterMessage }}</p>
		</div>

		<div class="inventory detail">
			<loading v-if="loading" class="loading"></loading>
			<div v-else class="list">
				<draggable class="distributor-items" handle=".drag" :sort="true" v-model="list" @end="endDrag" group="distributor_items" tag="div">
					<div v-for="(item, index) in list" class="distributor-item draggable" :key="item.distributor_id" @click="getItem(item)">
						<div>{{ item.priority }}</div>
						<div>{{ item.distributor_code }}</div>
						<div>{{ item.company_name }}</div>
						<div class="center"><span v-if="item.auto_order">Auto Order</span><span v-else><s>Auto Order</s></span></div>
						<div class="center"><span v-if="item.inactive"><s>On Website</s></span><span v-else>On Website</span></div>
						<div class="drag right"><i class="fas fa-grip-vertical"></i></div>
					</div>
				</draggable>
			</div>
		</div>

		<div v-if="showModal" class="modal">
			<div class="inner" style="max-height: 40em;">
				<h2>{{ listDetail.company_name }}</h2>
				<div class="content" style="max-height: 30em;">
					<div class="two-columns ">
						<div v-if="listDetail.distributor_code == 'RSR'">
							<label>Account Number</label>
							<input type="text" v-model="listDetail.account_number" />
							<label>Dropship Account</label>
							<input type="text" v-model="listDetail.fulfillment_username" />
							<label>FTP Password</label>
							<input type="text" v-model="listDetail.fulfillment_password" />
						</div>
						<div v-if="listDetail.distributor_code == 'SS'">
							<label>Account Number</label>
							<input type="text" v-model="listDetail.account_number" />
							<label>Password</label>
							<input type="text" v-model="listDetail.fulfillment_password" />
						</div>
						<div v-if="listDetail.distributor_code == 'LIP'">
							<p class="note">Fulfillment Orders</p>
							<label>Email Address</label>
							<input type="text" v-model="listDetail.fulfillment_username" />
							<label>Password</label>
							<input type="text" v-model="listDetail.fulfillment_password" />
							<p class="note">Dropship Orders</p>
							<label>Email Address</label>
							<input type="text" v-model="listDetail.dropship_username" />
							<label>Password</label>
							<input type="text" v-model="listDetail.dropship_password" />
						</div>
						<div v-if="listDetail.distributor_code == 'ZAN'">
							<label>Main Account Username</label>
							<input type="text" v-model="listDetail.account_number" />
							<label>Main Account Passcode</label>
							<input type="text" v-model="listDetail.api_key" />
							<label>Firearms Dropship Account Username</label>
							<input type="text" v-model="listDetail.fulfillment_username" />
							<label>Firearms Dropship Account Passcode</label>
							<input type="text" v-model="listDetail.fulfillment_password" />
							<label>Accessories Dropship Account Username</label>
							<input type="text" v-model="listDetail.dropship_username" />
							<label>Accessories Dropship Account Passcode</label>
							<input type="text" v-model="listDetail.dropship_password" />
						</div>
						<div>
							<p><checkbox v-model="listDetail.auto_order" label="Auto Fulfill Orders"/></p>
							<p><checkbox v-model="listDetail.drop_ship" label="Auto Dropship Orders"/></p>
							<p><checkbox v-model="listDetail.firearms_drop_ship" label="Firearms Dropship Enabled"/></p>
							<p><checkbox v-model="listDetail.inactive" :label="'Hide ' + listDetail.distributor_code + ' Exclusive Products'"/></p>
						</div>
					</div>
					<p v-if="listDetail.distributor_code == 'RSR'" class="note">Your main Account Number and FTP Password will be used to upload orders to RSR.</p>
					<p v-if="listDetail.distributor_code == 'SS'" class="note">Sports South uses the same login for both fulfillment and dropship orders.</p>
					<p v-if="listDetail.distributor_code == 'LIP'" class="note">Lipsey's requires separate accounts for fulfillment and drop ship orders.</p>
					<p v-if="modalMessage" class="message center">{{ modalMessage }}</p>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="backToList()">Cancel</div>
					<div v-if="listDetail.distributor_code != 'LIP'" class="button neutral spaced" @click="testConnection()">Test Account</div>
					<div :class="['button', 'spaced', saving ? 'disabled' : 'action']" @click="saveItem()">Save Details</div>
				</div>
			</div>
		</div>

	</div>
</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import Checkbox from '@/components/Checkbox.vue'
export default {
	name: 'calibers',
	components: {
		'loading': Loading,
		Checkbox
	},
	data() {
		return {
			client_id: '',
			loading: true,
			filters: {
				page: 1,
				search_term: '',
				merge_search_term: '',
				current_id: '',
				internal_use_only: 0,
				inactive: 0,
				client: 0,
				do_export: 0
			},
			filterMessage: '',
			showModal: false,
			list: [],
			listDetail: {},
			saving: false,
			modalMessage: '',
			modalSuccess: false
		}
	},
	created() {
		// this.clearFilters(true)
		this.getList()
	},
	computed: {
		canSave() {
			return this.listDetail.description
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				auto_pilot: false
			}
			if (getList) {
				this.getList()
			}
		},
		getList() {
			this.loading = true
			this.apiCall({ destination: 'get_list_client_distributors', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.list = obj.client_distributors
			}).catch(err => {
				console.log(err)
			})
		},
		endDrag() {
			let sortedList = []
			sortedList = this.list.map((item, index) => {
				item.priority = index + 1
				return item
			})
			this.list = sortedList
		},
		savePreferenceOrder() {
			if (this.saving) { return }
			this.saving = true
			this.filterMessage = 'Saving...'
			let priorityList = {}
			// iterate the list and add the key distributor_id value sort_order to the priorityList
			this.list.forEach(item => {
				priorityList['priority_' + item.distributor_id] = item.priority
			})
			this.apiCall({ destination: 'save_item_client_distributor_order', data: priorityList }).then(obj => {
				if (obj.status == 'success') {
					this.filterMessage = 'Preference order saved!'
					setTimeout(() => {
						this.filterMessage = ''
						this.saving = false
					}, 2000);
				} else {
					this.filterMessage = obj.message
					setTimeout(() => { this.filterMessage = '' }, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getItem(item) {
			this.listDetail = item
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Saving...'
			this.apiCall({ destination: 'save_item_client_distributor_details', data: this.listDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Account details saved!'
					setTimeout(() => {
						this.backToList()
						this.modalMessage = ''
					}, 2000);
				} else {
					this.modalMessage = obj.message
					setTimeout(() => { this.modalMessage = '' }, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		testConnection(item) {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Testing...'
			this.apiCall({ destination: 'test_client_distributor_connection', data: this.listDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Account test succeeded!'
					setTimeout(() => {
						this.backToList()
						this.modalMessage = ''
					}, 2000);
				} else {
					this.modalMessage = obj.message
					setTimeout(() => { this.modalMessage = '' }, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showModal = false
			this.listDetail = {}
		}
	}
}
</script>

<style lang="scss" scoped>
.draggable {
	.drag {
		cursor: move;
	}
}
.template-content .sortable-ghost {
	border: 1px solid gray;
	min-height: 2em;
}
.sortable-drag {
	cursor: grabbing;
	opacity: 0.5;
}
.sortable-chosen {
	cursor: grabbing;
	color: red;
	opacity: 0.5;
}
.distributor-item {
	background-color: white;
	border: 1px solid #ccc;
	padding: 1em;
	margin: 1em;
	display: grid;
	grid-template-columns: 4em 6em 1fr 10em 10em 6em;
	align-items: center;
}
</style>
